import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from 'antd';
import { sumBy } from 'lodash';

import { colorToPercent } from 'utils/ranking';

import './FishboneBranch.sass';
import { FishbonePin } from './FishbonePin';
import { FishboneBranchContent } from './FishboneBranchContent';
import { fal } from '@fortawesome/pro-light-svg-icons';

const headSpace = 65
const oddOffset = 28
const baseBottomYOffset = -17
const baseTopYOffset = 17

export const FishboneBranch = (props: any) => {
	const { t } = useTranslation();

	const titleDY = props.position == "top" ? (props.odd ? baseTopYOffset : baseTopYOffset + oddOffset) : (props.odd ? baseBottomYOffset - oddOffset : baseBottomYOffset)
	const titleDX = props.position == "top" ? (props.odd ? -45 : -35) : (props.odd ? -50 : -25)

	const allPoints = props.points || [];
	//sortBy(props.points || [], (p) => (p && p.completion) || 0).reverse()


	let pointsWeight = 0;
	allPoints.forEach((p) => (pointsWeight += p.weight || 1));

	const vulnerability =
		allPoints && allPoints.length > 0
			? sumBy(
				allPoints,
				(p) =>
					colorToPercent(p.trend !== null ? p.trend : '50') *
					(p.weight || 1)
			) / pointsWeight
			: 50;

	const completion =
		allPoints && allPoints.length > 0
			? sumBy(allPoints, (p) => (p.completion || 0) * (p.weight || 1)) /
			pointsWeight
			: 0;

	const icon = props.icon || 'faCrosshairs';
	const iconDetails = fal[icon];
	
	// Pas d'effet ripple pour les branches au démarrage
	// On pourrait ajouter un prop isAppearing si on veut le ripple sur nouvelles branches
	
	return (
		<g
			className={`FishboneBranch ${props.isMatching ? "matching" : ""} ${props.dragOver ? 'drag-over' : ''} ${props.branchDropTarget ? 'branch-drop-target' : ''} ${props.draggingBranch?.id === props.id ? 'dragging-branch' : ''} ${props.highlight ? 'highlight' : ''}`}
			transform={`translate(${props.leftOffset}, ${props.topOffset})`}
			onMouseEnter={() => (props.draggingItem || props.draggingBranch) && props.onBranchEnter && props.onBranchEnter()}
			onMouseLeave={() => (props.draggingItem || props.draggingBranch) && props.onBranchLeave && props.onBranchLeave()}
			onMouseUp={(e) => {
				if ((props.draggingItem || props.draggingBranch) && props.onDropOnBranch) {
					props.onDropOnBranch();
					e.stopPropagation();
				}
			}}
		>
			<g
				className="FishboneBranchTitle"
				style={{ cursor: 'pointer' }}
				onClick={() => props.onSelectItem(props)}
				onDoubleClick={(e) => { e.stopPropagation(); props.onEditBranch && props.onEditBranch(props); }}
			>
				<g
					transform={
						'translate(' + (titleDX) + ', ' +
						(props.position == 'bottom' ? props.height - headSpace - titleDY : titleDY) + ')'
					}
				>

					<FishbonePin weight={props.weight} trend={vulnerability} completion={completion}></FishbonePin>

					{iconDetails && <svg viewBox={`0 0 ${iconDetails?.icon[0]} ${iconDetails?.icon[1]}`} fill={props.selected ? "orange" : 'var(--ant-color-text)'} stroke={'none'} width={18} height={16} x={22} y={-8}>
						<path d={(iconDetails?.icon[4])} />
					</svg>
					}

					<text
						className={'title'}
						fontSize={16}

						fill={props.selected ? "orange" : 'var(--ant-color-text)'}
						dx={50}
						dy={4}
					>

						{props.name}
					</text>
				</g>
			</g>

			< g className="LineGroup" >
				{/* Aura line behind branch */}
				<line
					x2={0}
					x1={props.width}
					y2={props.position == "bottom" ? props.height - headSpace : headSpace}
					y1={props.position == "bottom" ? 0 : props.height}
					stroke="#FFC107"
					strokeOpacity={0}
					strokeWidth={36}
					strokeLinecap="round"
					className="aura"
				></line>
				<line
					x2={0}
					x1={props.width}
					y2={props.position == "bottom" ? props.height - headSpace : headSpace}
					y1={props.position == "bottom" ? 0 : props.height}
					stroke="#A6B9C8"
					strokeLinecap="round"
					className="main"
				></line>
			</g >

			<g className="LineGroup">
				<line
					x2={0}
					x1={props.width}
					y2={props.position == "bottom" ? props.height - headSpace : headSpace}
					y1={props.position == "bottom" ? 0 : props.height}
					stroke="#FFFFFF00"
					strokeWidth={20}
					strokeLinecap="round"
					className="wrapper"
					pointerEvents="none"
				></line>
				{!props.draggingItem && props.onCreateItem && (<Tooltip title={t('models.fishbone_item.actions.add')}><g
					className="add"
					onClick={props.onCreateItem}
					transform={
						'translate(' +
						(props.width) +
						' ' +
						(props.height * (props.position == "bottom" ? 0 : 1)) +
						')'
					}
				>
					<circle r={15} fill={'#CCCCCC'}></circle>
					<text fontSize={36} dx={-10} dy={13}>
						+
					</text>
				</g></Tooltip>)}
			</g>

			<g transform={"translate(" + 0 + ", " + (props.position == "bottom" ? 0 : headSpace) + ")"}>
				<FishboneBranchContent
					{...props}
					onSelectItem={props.onSelectItem}
					width={props.width}
					height={props.height - headSpace}
					selection={props.selection}
					onStartDragItem={props.onStartDragItem}
					onItemDragEnter={props.onItemDragEnter}
					dropTargetItemId={props.dropTargetItemId}
					dropTargetSide={props.dropTargetSide}
					odd={props.odd}
					branchIndex={props.branchIndex}
				></FishboneBranchContent>
			</g>
		</g>
	);
};
